/**
 * Subscription error codes
 * RUM only allows a-z, 0-9, and underscores in error types.
 */

// eslint-disable-next-line no-shadow
enum SubscriptionErrorCodes {
  // General errors
  FailedToFetchAvailablePlans = 'subscription_error_failed_to_fetch_available_plans',
  // Analytics errors
  AnalytixFailedToGetSession = 'subscription_error_analytix_failed_to_get_session',
  // Paddle errors
  PaddleGatewayError = 'subscription_error_paddle_gateway_error',
  PaddleInvalidPlanId = 'subscription_error_paddle_invalid_plan_id',
  PaddleFailedToInitialize = 'subscription_error_paddle_failed_to_initialize',
  PaddleSyncFailed = 'subscription_error_paddle_sync_failed',
  // PayPal errors
  PayPalGatewayError = 'subscription_error_paypal_gateway_error',
  PayPalFailedToAuthenticateCaptcha = 'subscription_error_paypal_failed_to_authenticate_captcha',
  PayPalFailedToGenerateVid = 'subscription_error_paypal_failed_to_generate_vid',
  PayPalSyncFailed = 'subscription_error_paypal_sync_failed',
  // Recurly errors
  RecurlyFailedToInitialize = 'subscription_error_recurly_failed_to_initialize',
  RecurlyFinalizeFailed = 'subscription_error_recurly_finalize_failed',
  RecurlyApplePayFailed = 'subscription_error_recurly_apple_pay_failed',
  RecurlyPaypalFailed = 'subscription_error_recurly_paypal_failed',
  RecurlyCreditCardFailed = 'subscription_error_recurly_credit_card_failed',
  RecurlyGeneralError = 'subscription_error_recurly_general_error',
  RecurlyTokenGenerationFailed = 'subscription_error_recurly_token_generation_failed',
  RecurlyCashAppFailed = 'subscription_error_recurly_cash_app_failed'
}

export default SubscriptionErrorCodes
